import { type Common } from './common.js';
import { type InsuranceProvider } from './models/insuranceProvider.js';

export class API {
  baseEndpoint = '/insurance-providers';
  common: Common;

  constructor(common: Common) {
    this.common = common;
  }

  async findOneById(id: string): Promise<InsuranceProvider> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${id}`);
    const { insuranceProvider } = await this.common.getJSON(url);
    return insuranceProvider;
  }

  async findAll(): Promise<InsuranceProvider[]> {
    const url = this.common.constructPath(this.baseEndpoint);
    const { insuranceProviders } = await this.common.getJSON(url);
    return insuranceProviders;
  }
}
